// extracted by mini-css-extract-plugin
module.exports = {"container-authors":"styles_container-authors__spLsT","card-author":"styles_card-author__kRMYL","card-cta":"styles_card-cta__YPsmt"};